import React, { useEffect, useState } from "react";
import { Tab, Nav, Modal, Button } from "react-bootstrap";

import AllOrder from "../../../components/Report/History/AllOrder";
import OrderHistory from "../../../components/Report/History/OrderHistory";
import { useDispatch, useSelector } from "react-redux";
import { getInvoicesListApi } from "../../../../service/bankApi/getInvoiceList";
import { approveInvoiceApi } from "../../../../service/bankApi/approveInvoice";
import { cancelInvoiceApi } from "../../../../service/bankApi/cancelInvoice";
import { toast, ToastContainer } from "react-toastify";
import ApproveInvoiceTable from "./approveInvoiceTable";
import PendingInvoiceTable from "./pendingInvoiceTable";
import { useNavigate } from "react-router-dom";
import { auditInvoiceApi } from "../../../../service/bankApi/auditInvoice";
import AutohideToaster from "../../Toaster/Toaster";
import RejectedInvoiceTable from "./rejectedInvoiceTable";
import PaidInvoiceTable from "./paidInvoiceTable";
import PendingPaymentInvoiceTable from "./pendingPayment";
import { setInvoiceListTab, setLoading } from "../../../../feature/authSlice";
import UnIdentifiedBillsTable from "./unIdentifiedBillsTable";
import { formatDate } from "../../../../function/commonFunction";
import OtpModal from "../../OtpModal/OtpModal";
import dayjs from "dayjs";
import { useLocation, useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Paper,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import PendingForApprovalInvoiceTable from "./pendingForApprovalInvoiceTable";
import { v4 as uuidv4 } from "uuid";
import { submitForApproval } from "../../../../service/bankApi/submitForApproval";
import { redirectToDash } from "../../../pages/redirectToDash";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";

const InvoiceList = () => {
  const { invoiceListTab } = useSelector((state) => state.auth);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { permissionArr } = useSelector((state) => state.auth);
  const hasTelephoneRole = permissionArr.some(role => /telephone/i.test(role));
  const isAdmin = permissionArr.some(role => /admin/i.test(role));
  // Access a specific parameter
  const [status, setStatus] = useState(queryParams.get("status"));
  const [filterType, setFilterType] = useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");

  const notifyTopRightDynamic = (e, s) => {
    if (s == "s") {
      toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const columns = [
    {
      Header: "",
      Footer: "",
      accessor: "hh",
    },
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),
    {
      Header: "Invoice  date",
      Footer: "Invoice  date",
      accessor: "InvoiceDate",
    },
    // {
    //   Header: "Total Amount",
    //   Footer: "Total Amount",
    //   accessor: "TotalAmount",
    // },
    // Conditionally add the "Invoice Type" column
    isAdmin?
    filterType==="Telephone"?
   {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    }:hasTelephoneRole?
    {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },
    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "Action",
      accessor: "action",
    },
  ];
  const PFAColumns = [
    {
      Header: "",
      Footer: "",
      accessor: "hh",
    },
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    // Conditionally add the "Invoice Type" column
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),
    {
      Header: "Invoice  date",
      Footer: "Invoice  date",
      accessor: "InvoiceDate",
    },
    // {
    //   Header: "Total Amount",
    //   Footer: "Total Amount",
    //   accessor: "TotalAmount",
    // },
    // Conditionally add the "Invoice Type" column
    isAdmin?
    filterType==="Telephone"?
   {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    }:hasTelephoneRole?
    {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },

    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "Action",
      accessor: "action",
    },
  ];
  const approvedColumns = [
    {
      Header: "",
      Footer: "",
      accessor: "action",
    },
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    // Conditionally add the "Invoice Type" column
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),
    {
      Header: "Invoice  date",
      Footer: "Invoice  date",
      accessor: "InvoiceDate",
    },
    // Conditionally add the "Invoice Type" column
    isAdmin?
    filterType==="Telephone"?
   {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    }:hasTelephoneRole?
    {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },

        
    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "",
      accessor: "kshgjg",
    },
  ];
  const unBillColumns = [
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    // Conditionally add the "Invoice Type" column
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),
    {
      Header: "Invoice  date",
      Footer: "Invoice  date",
      accessor: "InvoiceDate",
    },
    // {
    //   Header: "Invoice due date",
    //   Footer: "Invoice due date",
    //   accessor: "InvoiceDueDate",
    // },
    // {
    //   Header: "Amount",
    //   Footer: "Amount",
    //   accessor: "Amount",
    // },
    // {
    //   Header: "Tax Amount",
    //   Footer: "Tax Amount",
    //   accessor: "TotalTaxValue",
    // },
    // {
    //   Header: "Total Amount",
    //   Footer: "Total Amount",
    //   accessor: "TotalAmount",
    // },
    {
      Header: "Remark",
      Footer: "Remark",
      accessor: "Remark",
    },
    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "Action",
      accessor: "action",
    },
  ];
  const paidColumn = [
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    // {
    //   Header: "Location Address",
    //   Footer: "Location Address",
    //   accessor: "SupplierAddress",
    // },
    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    // Conditionally add the "Invoice Type" column
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),

    {
      Header: "Payment  date",
      Footer: "Payment  date",
      accessor: "PaymentDate",
    },
    // {
    //   Header: "Amount",
    //   Footer: "Amount",
    //   accessor: "Amount",
    // },
    // {
    //   Header: "Tax Amount",
    //   Footer: "Tax Amount",
    //   accessor: "TotalTaxValue",
    // },
    // {
    //   Header: "Total Amount",
    //   Footer: "Total Amount",
    //   accessor: "TotalAmount",
    // },
    // Conditionally add the "Invoice Type" column
    isAdmin?
    filterType==="Telephone"?
   {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    }:hasTelephoneRole?
    {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },
        
    // {
    //   Header: "UTR",
    //   Footer: "UTR",
    //   accessor: "UTR",
    // },
    // {
    //   Header: "TDS",
    //   Footer: "TDS",
    //   accessor: "TDS",
    // },
    // {
    //   Header: "Amount Paid",
    //   Footer: "Amount Paid",
    //   accessor: "NetAmontPaid",
    // },
    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "",
      accessor: "skdjfnkl",
    },
  ];
  const pendingPaymentsColumn = [
    {
      Header: " ",
      Footer: " ",
      accessor: "hhhh",
    },
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    // {
    //   Header: "Location Address",
    //   Footer: "Location Address",
    //   accessor: "SupplierAddress",
    // },
    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    // Conditionally add the "Invoice Type" column
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),
    // {
    //   Header: "Generation Time",
    //   Header: "Generation Time",
    //   accessor: "OutputFileGeneratedAt",
    // },

    {
      Header: "Invoice  date",
      Footer: "Invoice  date",
      accessor: "InvoiceDate",
    },
    // {
    //   Header: "Invoice due date",
    //   Footer: "Invoice due date",
    //   accessor: "InvoiceDueDate",
    // },
    // {
    //   Header: "Amount",
    //   Footer: "Amount",
    //   accessor: "Amount",
    // },
    // {
    //   Header: "Tax Amount",
    //   Footer: "Tax Amount",
    //   accessor: "TotalTaxValue",
    // },
    // {
    //   Header: "Total Amount",
    //   Footer: "Total Amount",
    //   accessor: "TotalAmount",
    // },
    // Conditionally add the "Invoice Type" column
    isAdmin?
    filterType==="Telephone"?
   {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    }:hasTelephoneRole?
    {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },
    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "",
      accessor: "dfdfgvc",
    },
  ];
  const rejectionColumns = [
    {
      Header: "Vendor Name",
      Footer: "Vendor Name",
      accessor: "SupplierName",
    },

    // {
    //   Header: "Location Address",
    //   Footer: "Location Address",
    //   accessor: "SupplierAddress",
    // },
    {
      Header: "Invoice No",
      Footer: "Invoice No",
      accessor: "InvoiceNo",
    },
    // {
    //   Header: "Invoice  Type",
    //   Header: "Invoice  Type",
    //   accessor: "InvoiceType",
    // },
    // Conditionally add the "Invoice Type" column
    ...(/telephone/i.test(permissionArr[0]) // Regular expression to search for "Telephone" (case-insensitive)
      ? [] // If it contains "Telephone", don't add the "Invoice Type" column
      : [
          {
            Header: "Invoice Type",
            Footer: "Invoice Type",
            accessor: "InvoiceType",
          },
        ]),
    {
      Header: "Invoice  date",
      Footer: "Invoice  date",
      accessor: "InvoiceDate",
    },
    // {
    //   Header: "Invoice due date",
    //   Footer: "Invoice due date",
    //   accessor: "InvoiceDueDate",
    // },
    // {
    //   Header: "Amount",
    //   Footer: "Amount",
    //   accessor: "Amount",
    // },
    // {
    //   Header: "Tax Amount",
    //   Footer: "Tax Amount",
    //   accessor: "TotalTaxValue",
    // },
    // {
    //   Header: "Total Amount",
    //   Footer: "Total Amount",
    //   accessor: "TotalAmount",
    // },
    // Conditionally add the "Invoice Type" column
    isAdmin?
    filterType==="Telephone"?
   {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    }:hasTelephoneRole?
    {
      Header: "Current Month Charges",
      Footer: "Current Month Charges",
      accessor: "CurrentMonthTotalPayableCharges",
    }  : {
      Header: "Total Amount",
      Footer: "Total Amount",
      accessor: "TotalAmount",
    },
      //  filterType==="Telephone"?{
      //   Header: "Current Month Charges",
      //   Footer: "Current Month Charges",
      //   accessor: "CurrentMonthTotalPayableCharges",
      //  }:{
      //   Header: "Total Amount",
      //   Footer: "Total Amount",
      //   accessor: "TotalAmount",
      //  } ,

    // {
    //   Header: "Rejection Reason",
    //   Footer: "Rejection Reason",
    //   accessor: "RejectionReason",
    // },
    {
      Header: "Location Code",
      Header: "Location Code",
      accessor: "LocationCode",
    },
    {
      Header: "Action",
      Footer: "",
      accessor: "asfkbjv ",
    },
  ];
  const notifyTopRight = () => {
    toast.success("✔️ Approved Successfully !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyTopRightDownlaod = () => {
    toast.success("✔️ Downloaded Successfully !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const [openTab, setOpenTab] = useState(2);
  const [approvedArr, setApprovedArr] = useState([]);
  const [pendingArr, setPendingArr] = useState([]);
  const [pfaArr, setPFAArr] = useState([]);
  const [permissionModal, setPermissionModal] = useState(false);
  const [cancelInvoiceId, setCancelInvoiceId] = useState("");

  const [permissionModalText, setPermissionModalText] = useState("");
  const [approveInvoiceId, setApproveInvoiceId] = useState(null);
  const [approveFileId, setApproveFileId] = useState(null);
  const [cancelFileId, setCancelFileId] = useState(null);
  const [modaleType, setModalType] = useState(null);
  const [actionPerformArray, setActionPerformArray] = useState([]);

  const [auditDisplay, setAuditDisplay] = useState(false);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [isApiLaoding, setApiLoading] = useState(false);
  const [actionMessage, setActionMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [toaster, setToaster] = useState(false);
  const [totalPagePendingCount, setTotalPendingCount] = useState(0);
  const [totalApprovedCount, setTotalApprovedCount] = useState(0);
  const [totalpendingPaymentCount, setTotalpendingPaymentCount] = useState(0);
  const [totalPaidCount, setTotalPaidCount] = useState(0);
  const [totalRejectedCount, setTotalRejectedCount] = useState(0);
  const [totalUnBillsCount, setTotalUnBillsCount] = useState(0);
  const [defaultTabKey, setDefaultTabKey] = useState("");
  const [reason, setReason] = useState("");
  const [pendingPaymentArr, setPaymentPendingArr] = useState([]);
  const [paymentPaidArr, setPaymentPaidArr] = useState([]);
  const [rejectedArr, setRejectedArr] = useState([]);
  const [unBillsArr, setUnBills] = useState([]);
  const [approveArrayData, setApproveArrayData] = useState([]);
  const [submitForApprovalArrayData, setSubmitForApproveArrayData] = useState(
    []
  );
  const [approveInvoiceModal, setApproveInvoiceModal] = useState(false);
  const [submitForApproveInvoiceModal, setSubmitForApproveInvoiceModal] =
    useState(false);
  const [otpModalStatus, setOtpModalStatus] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [totalPagePFACount, setTotalPFACount] = useState(0);

  //  Pending Array PAgination states
  const [pagePending, setPagePending] = useState(1);
  const [pageSizePending, setPageSizePending] = useState(10);
  const [totalPagePending, setTotalPagePending] = useState(1);
  const [searchValuePending, setSearchValuePending] = useState("");

  //  PFA Array PAgination states
  const [pagePFA, setPagePFA] = useState(1);
  const [pageSizePFA, setPageSizePFA] = useState(10);
  const [totalPagePFA, setTotalPagePFA] = useState(1);
  const [searchValuePFA, setSearchValuePFA] = useState("");

  //  Approved Array PAgination states

  const [pageApproved, setPageApproved] = useState(1);
  const [pageSizeApproved, setPageSizeApproved] = useState(10);
  const [totalPageApproved, setTotalPageApproved] = useState(1);
  const [searchValueApproved, setSearchValueApproved] = useState("");

  // Payment Pending Array PAgination states

  const [pagePaymentPending, setPagePaymentPending] = useState(1);
  const [pageSizePaymentPending, setPageSizePaymentPending] = useState(10);
  const [totalPagePaymentPending, setTotalPagePaymentPending] = useState(1);
  const [searchValuePaymentPending, setSearchValuePaymentPending] =
    useState("");

  // Paid Array PAgination states
  const [pagePaid, setPagePaid] = useState(1);
  const [pageSizePaid, setPageSizePaid] = useState(10);
  const [totalPagePaid, setTotalPagePaid] = useState(1);
  const [searchValuePaid, setSearchValuePaid] = useState("");

  // Reject Array PAgination states
  const [pageReject, setPageReject] = useState(1);
  const [pageSizeReject, setPageSizeReject] = useState(10);
  const [totalPageReject, setTotalPageReject] = useState(1);
  const [searchValueReject, setSearchValueReject] = useState("");

  // UB Array PAgination states
  const [pageUnBills, setPageUnBills] = useState(1);
  const [pageSizeUnBills, setPageSizeUnBills] = useState(10);
  const [totalPageUnBills, setTotalPageUnBills] = useState(1);
  const [searchValueUnBills, setSearchValueUnBills] = useState("");

  const [toDate, setToDate] = React.useState(dayjs(new Date()));
  const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
  const { permissions } = useSelector((state) => state.permissionsData);

  const [PFAShowAll, setPFAShowAll] = useState(false);

  const handlePFACheckboxChange = (value) => {
    setPFAShowAll((prev) => !prev); // Toggle between true and false
  };

  // const [newTab,setNewTab]=useState(false)
  // const [pendingForApprovalTab,setPendingForApprovalTab]=useState(false)
  let newTab = false;
  let pendingForApprovalTab = false;
  // Use the parameter as needed in your component
  React.useEffect(() => {
    if (status) {

      // You can now use the 'status' parameter in your logic
      // For example, fetch data based on status
    }
  }, [status]);

  // Helper function to find the "List Property" submenu within "Properties"
  const findListPropertySubMenus = () => {
    const propertiesMenu = permissions?.find(
      (menu) => menu?.MenuItemName === "Invoice"
    );
    if (!propertiesMenu) return [];

    const listPropertySubMenu = propertiesMenu?.SubMenus.find(
      (subMenu) => subMenu?.MenuItemName === "Invoice List"
    );
    if (!listPropertySubMenu) return [];
    return listPropertySubMenu?.SubMenus;
  };

  // Get the submenus of "List Property"
  const listPropertySubMenus = findListPropertySubMenus();

  useEffect(() => {
    const propertiesMenu = permissions?.find(
      (menu) => menu?.MenuItemName === "Invoice"
    );
    if (!propertiesMenu) return [];

    const listPropertySubMenu = propertiesMenu?.SubMenus.find(
      (subMenu) => subMenu?.MenuItemName === "Invoice List"
    );
    if (!listPropertySubMenu) return [];
    // Find submenus for "New" and "Pending for approval"
    const newSubMenu = listPropertySubMenu?.SubMenus.find(
      (subMenu) => subMenu?.MenuItemName === "New"
    );
    const pendingForApprovalSubMenu = listPropertySubMenu?.SubMenus.find(
      (subMenu) => subMenu?.MenuItemName === "Pending for Approval"
    );
    newTab = (newSubMenu?.MenuItemName === "New") === true;
    pendingForApprovalTab =
      pendingForApprovalSubMenu?.MenuItemName === "Pending for Approval";
  }, []);

  useEffect(() => {
    if (status === "Approved") {
      setDefaultTabKey("Approved");
      setOpenTab(1);
    } else if (status === "Payment Pending") {
      setDefaultTabKey("Pending Payment");
      setOpenTab(3);
    } else if (newTab) {
      setDefaultTabKey("New");
      setOpenTab(2);
    } else if (pendingForApprovalTab) {
      setDefaultTabKey("Pending for Approval");
      setOpenTab(9);
    }

    setPendingArr([]);
    setApprovedArr([]);
    setPaymentPendingArr([]);
    setPaymentPaidArr([]);
    setRejectedArr([]);
    setUnBills([]);
    setApiLoading(true);

    return () => {
      // dispatch(setInvoiceListTab(1))
      // setDefaultTabKey("Nav-History")
      // dispatch(setInvoiceListTab(1))
      // setDefaultTabKey("Nav-History")
    };
  }, [defaultTabKey]);

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);

    // Get year, month, and day from the date object
    const year = dateObject.getFullYear();
    const month = ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() is zero-indexed
    const day = ("0" + dateObject.getDate()).slice(-2);

    // Construct the formatted date string
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    onLoadData();
    // tabChanged()
  }, [
    openTab,
    pagePending,
    pageApproved,
    pagePaymentPending,
    pageReject,
    pagePaid,
    pageUnBills,
    pageSizePending,
    pageSizeApproved,
    pageSizePaymentPending,
    pageSizePaid,
    pageSizeReject,
    pageSizeUnBills,
    pageSizePFA,
    pagePFA,
    PFAShowAll
  ]);
  function onLoadData(val, val2) {
    let filterType2 = filterType;
    switch (filterType!=='' ? filterType : val2) {
      case "Telephone":
        filterType2 = "InvoiceType@=Telephone";
        break;
      case "Maintenance/Electricity":
        filterType2 = "InvoiceType!@=Telephone";
        break;
      default:
        filterType2 = "InvoiceType@=Telephone";
        break;
    }

    setApiLoading(true);
    if (openTab === 1) {
      var data = {
        Filter:
          formatDate(fromDate) !== formatDate(toDate)
            ? `status==1,InvoiceDueDate>=${formatDate(
                fromDate
              )},InvoiceDueDate<=${formatDate(toDate)}` +
              "," +
              filterType2
            : `status==1` + "," + filterType2,
        OrderBy: "-Id",
        PageSize: pageSizeApproved,
        PageNumber: pageApproved,
        Keyword: searchValueApproved,
      };

      dispatch(
        getInvoicesListApi(
          data,
          (response) => {
            setApiLoading(false);
            setApprovedArr(response.data.result.Invoices);
            setTotalApprovedCount(response.data.result.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPageApproved(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPageApproved(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    } else if (openTab == 2) {
      var data = {
        Filter:
          formatDate(fromDate) !== formatDate(toDate)
            ? `status==0,InvoiceDueDate>=${formatDate(
                fromDate
              )},InvoiceDueDate<=${formatDate(toDate)}` +
              "," +
              filterType2
            : "status==0" + "," + filterType2,
        OrderBy: "-Id",
        PageSize: pageSizePending,
        PageNumber: pagePending,
        Keyword: searchValuePending,
      };

      dispatch(
        getInvoicesListApi(
          data,
          (response) => {
            setApiLoading(false);
            setPendingArr(response.data.result.Invoices);
            setTotalPendingCount(response.data.result.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPagePending(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPagePending(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    } else if (openTab === 3) {
      var data = {
        // Filter:
        //   formatDate(fromDate) !== formatDate(toDate)
        //     ? `status==2,InvoiceDueDate>=${formatDate(
        //         fromDate
        //       )},InvoiceDueDate<=${formatDate(toDate)}` +
        //       "," +
        //       filterType2
        //     : "status==2" + "," + filterType2,
        Filter:
        formatDate(fromDate) !== formatDate(toDate)
          ? `${isAdmin ? "status==11" : "status==2|11"},InvoiceDueDate>=${formatDate(
              fromDate
            )},InvoiceDueDate<=${formatDate(toDate)},${filterType2}`
          : `${isAdmin ? "status==11" : "status==2|11"},${filterType2}`,
        OrderBy: "-Id",
        PageSize: pageSizePaymentPending,
        PageNumber: pagePaymentPending,
        Keyword: searchValuePaymentPending,
      };

      dispatch(
        getInvoicesListApi(
          data,
          (response) => {
            setApiLoading(false);
            setPaymentPendingArr(response.data.result.Invoices);
            setTotalpendingPaymentCount(response?.data?.result?.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPagePaymentPending(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPagePaymentPending(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    } else if (openTab == 4) {
      var data = {
        Filter:
          formatDate(fromDate) !== formatDate(toDate)
            ? `status==3,InvoiceDueDate>=${formatDate(
                fromDate
              )},InvoiceDueDate<=${formatDate(toDate)}` +
              "," +
              filterType2
            : "status==3" + "," + filterType2,
        OrderBy: "-Id",
        PageSize: pageSizePaid,
        PageNumber: pagePaid,
        Keyword: searchValuePaid,
      };

      dispatch(
        getInvoicesListApi(
          data,
          (response) => {
            setApiLoading(false);
            setPaymentPaidArr(response.data.result.Invoices);
            setTotalPaidCount(response?.data?.result?.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPagePaid(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPagePaid(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    } else if (openTab == 5) {
      var data = {
        Filter:
          formatDate(fromDate) !== formatDate(toDate)
            ? `status==4,InvoiceDueDate>=${formatDate(
                fromDate
              )},InvoiceDueDate<=${formatDate(toDate)}` +
              "," +
              filterType2
            : "status==4" + "," + filterType2,
        OrderBy: "-Id",
        PageSize: pageSizeReject,
        PageNumber: pageReject,
        Keyword: searchValueReject,
      };

      dispatch(
        getInvoicesListApi(
          data,
          (response) => {
            setApiLoading(false);
            setRejectedArr(response.data.result.Invoices);
            setTotalRejectedCount(response?.data?.result?.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPageReject(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPageReject(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    } else if (openTab == 6) {
      var data = {
        Filter:
          formatDate(fromDate) !== formatDate(toDate)
            ? `status==6,InvoiceDueDate>=${formatDate(
                fromDate
              )},InvoiceDueDate<=${formatDate(toDate)}` +
              "," +
              filterType2
            : "status==6" + "," + filterType2,
        OrderBy: "-Id",
        PageSize: pageSizeUnBills,
        PageNumber: pageUnBills,
        Keyword: searchValueUnBills,
      };

      dispatch(
        getInvoicesListApi(
          data,
          (response) => {
            setApiLoading(false);
            setUnBills(response.data.result.Invoices);
            setTotalUnBillsCount(response?.data?.result?.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPageUnBills(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPageUnBills(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    } else if (openTab == 9) {
      var data = {
        Filter:
          formatDate(fromDate) !== formatDate(toDate)
            ? `status==9,InvoiceDueDate>=${formatDate(
                fromDate
              )},InvoiceDueDate<=${formatDate(toDate)}` +
              "," +
              filterType2
            : `status==9` + "," + filterType2,
        OrderBy: "-Id",
        PageSize: pageSizePFA,
        PageNumber: pagePFA,
        Keyword: searchValuePFA,
      };

      var baseFilter = [];

      if (formatDate(fromDate) !== formatDate(toDate)) {
        baseFilter.push(`InvoiceDueDate>=${formatDate(fromDate)},InvoiceDueDate<=${formatDate(toDate)}`);
      }
      
      if (PFAShowAll === true) {
        baseFilter.push(`status==9|10`);
      } 
      
      if (filterType2) {
        baseFilter.push(filterType2);
      }
      
      var data2 = {
        Filter: baseFilter.join(","), // Combine all filters correctly
        OrderBy: "-Id",
        PageSize: pageSizePFA,
        PageNumber: pagePFA,
        Keyword: searchValuePFA,
        ShowAll: PFAShowAll
      };

      dispatch(
        getInvoicesListApi(
          filterType!=="Telephone"?data:data2,
          (response) => {
            setApiLoading(false);
            setPFAArr(response.data.result.Invoices);
            setTotalPFACount(response.data.result.TotalCount);
            if (
              parseInt(response?.data?.result?.TotalCount) %
                response.data.result.PageSize ===
              0
            ) {
              setTotalPagePFA(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize
                )
              );
            } else {
              setTotalPagePFA(
                parseInt(
                  response?.data?.result?.TotalCount /
                    response.data.result.PageSize +
                    1
                )
              );
            }
          },
          (error) => {
            setApiLoading(false);
          }
        )
      );
    }
  }
  const [typingTimeout, setTypingTimeout] = useState(null);

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after the user stops typing
    const timeoutId = setTimeout(() => {
      onLoadData(); // Call your API with the current search value
    }, 1000); // Adjust the delay as needed (500ms in this case)

    // Save the timeout ID
    setTypingTimeout(timeoutId);

    // Clean up the timeout when the component unmounts or values change
    return () => clearTimeout(timeoutId);
  }, [
    searchValueApproved,
    searchValuePaid,
    searchValuePaymentPending,
    searchValuePending,
    searchValueReject,
    searchValueUnBills,
    searchValuePFA
  ]);

  function handleInvoiceAcceptReject(id, action, data) {
    if (action == "cancel") {
      setModalType(0);
      setPermissionModal(true);
      setCancelInvoiceId(data.Id);
      setCancelFileId(data.FileId);
    } else if (action == "approve") {
      setModalType(1);

      setPermissionModal(true);
      setApproveInvoiceId(data.Id);
      setApproveFileId(data.FileId);
    } else if (action == "view") {
      localStorage.setItem("FilePath", data.FilePath);
      navigate("/pdfView");
    } else if (action == "edit") {
      var data = {
        FilePath: data.FilePath,
        Value: data,
      };
      const dataToSend = { Id: data.Value.Id, data: data, tab: defaultTabKey };
      // localStorage.setItem("invoiceId", data.Value.Id)
      localStorage.setItem("verifyEditObject", JSON.stringify(data));
      if (
        data.Value.InvoiceType &&
        data.Value.InvoiceType.includes("Telephone")
      ) {
        navigate("/viewTelephoneInvoiceScreen", { state: dataToSend });
      } else {
        navigate("/verificationEditScreen", { state: dataToSend });
      }
      // navigate(`/verificationEditScreen?Id=${data.Value.Id}`);
    } else if (action == "audit") {
      var data = {
        InvoiceId: data.Id,
        FileId: data.FileId,
      };
      dispatch(
        auditInvoiceApi(
          data,
          (res) => {
            setAuditDisplay(true);
            setActionPerformArray(res.data.result);
            onLoadData();
          },
          (err) => {
  
          }
        )
      );
    }
  }
  function handleApproveCalled() {
    setApiLoading(true);
    var data = [
      {
        InvoiceId: approveInvoiceId,
        FileId: approveFileId,
      },
    ];
    dispatch(
      approveInvoiceApi(
        data,
        (res) => {
          setApiLoading(false);
          setPermissionModal(false);
          onLoadData();
          notifyTopRight();
        },
        (err) => {
          setApiLoading(false);
        }
      )
    );
  }
  function handleCancelCalled() {
    setApiLoading(true);
    var data = {
      InvoiceId: cancelInvoiceId,
      FileId: cancelFileId,
      RejectionReason: reason,
    };
    if (reason !== "") {
      try {
        dispatch(
          cancelInvoiceApi(
            data,
            (res) => {
              onLoadData();
              setApiLoading(false);
              setReason("");
              setPermissionModal(false);
              toast.success("Invoice rejected successfully");
            },
            (err) => {
              setApiLoading(false);

              setReason("");
            }
          )
        );
      } catch (error) {
        setReason("");
      }
    } else {
      toast.error("Please provide a reason");
    }
  }
  const toggleRowExpansion = (index) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  function parseStringToObjects(inputString) {
    // Removing escape characters from the input string
    inputString = inputString?.replace(/\\"/g, '"').replace(/\\'/g, "'");

    // Parsing the string into a JavaScript object
    let data = JSON.parse(inputString);
    return data;
  }
  const getCurrentDateTimeString = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year}_${hours}${":"}${minutes}`;
  };
  function handleFileDownload(base) {
    const binaryData = atob(base);

    // Convert binary data to array buffer
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create Blob from array buffer
    const blob = new Blob([uint8Array], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = url;
    const currentDateTimeString = getCurrentDateTimeString();
    link.download = `VBMS_${currentDateTimeString}.xlsx`; // Set desired file name here
    document.body.appendChild(link);
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
    notifyTopRightDownlaod();
  }
  function handleMISFileDownload(base) {
    const binaryData = atob(base);

    // Convert binary data to array buffer
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create Blob from array buffer
    const blob = new Blob([uint8Array], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = url;
    const currentDateTimeString = getCurrentDateTimeString();
    link.download = `MIS_${currentDateTimeString}_V29NRB.xlsx`; // Set desired file name here
    document.body.appendChild(link);
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
    notifyTopRightDownlaod();
  }

  function handlePaymentFileDownload(base) {
    // Define the HdfcFileName
    const HdfcFileName = "V29N";

    // Get the current date and time in Indian Standard Time
    const indianDate = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
    });
    const date = new Date(indianDate);

    // Format the date and month
    const Month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const Day = String(date.getDate()).padStart(2, "0");

    // Create the filename
    const fileName = `${HdfcFileName}${Day}${Month}.001`;

    // Convert base64 data to binary
    const binaryData = atob(base);

    // Convert binary data to array buffer
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create Blob from array buffer
    const blob = new Blob([uint8Array], { type: "text/plain" });

    // Create URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName; // Set desired file name here
    document.body.appendChild(link);
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
    notifyTopRightDownlaod();
  }
  function handlePaymentAdviceFileDownload(pdfData) {
    try {
      const { FileBytes, Name } = pdfData?.result || {};
  
      if (!FileBytes || !Name) {
        toast.error("Invalid file data.");
        return;
      }
  
      // Convert base64 string to a byte array
      const byteCharacters = atob(FileBytes);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
  
      // Create a Blob from the byte array
      const blob = new Blob([byteArray], { type: "application/pdf" });
  
      // Generate a URL for the Blob
      const url = URL.createObjectURL(blob);
  
      // Create a download link
      const link = document.createElement("a");
      link.href = url;
      link.download = Name; // Use filename from API
      document.body.appendChild(link);
      link.click();
  
      // Cleanup
      URL.revokeObjectURL(url);
      document.body.removeChild(link);
  
      notifyTopRightDownlaod(); // Notify user that download has started
      onLoadData()
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toast.error("Failed to download the file.");
    }
  }

  function handleActionMultipleApprove(data) {
    setApproveInvoiceModal(true);
    setApproveArrayData(data);
  }
  function handleActionMultipleSubmitForApprove(data) {
    setSubmitForApproveInvoiceModal(true);
    setSubmitForApproveArrayData(data);
  }

  function handleMultipleApproveCalled() {
    setApiLoading(true);

    var data = {
      ResendOtp: false,
      OTP: otpValue,
      approveList: approveArrayData,
    };

    try {
      dispatch(
        approveInvoiceApi(
          data,
          (res) => {
            setApiLoading(false);

            if (res.data.result.ResponseMessage === "OTP sent successfully") {
              setOtpModalStatus(true);
              setApproveInvoiceModal(false);
              toast.success(res.data.result.ResponseMessage);
            } else {
              setOtpValue("");
              setOtpModalStatus(false);
              setApproveInvoiceModal(false);
              onLoadData();

              notifyTopRight();
            }
          },
          (err) => {
            setApiLoading(false);
          }
        )
      );
    } catch (error) {}
  }

  function handleMultipleSubmitForApproveCalled() {
    setApiLoading(true);

    const data = submitForApprovalArrayData.map((item) => item.InvoiceId);

    try {
      dispatch(
        submitForApproval(
          data,
          (res) => {
            setApiLoading(false);
            if (res.data.message === "POST Request successful.") {
              setSubmitForApproveInvoiceModal(false);
              toast.success("Submitted for approval successfully.");
              onLoadData();

            } else {
              setSubmitForApproveInvoiceModal(false);
              onLoadData();
            }
          },
          (err) => {
            setApiLoading(false);
          }
        )
      );
    } catch (error) {}
  }

  function handleApproveInvoiceOtp(element) {
    setOtpValue(element);
  }

  function handleResendOtp() {
    var data = {
      ResendOtp: true,
      OTP: "",
      approveList: approveArrayData,
    };

    try {
      dispatch(
        approveInvoiceApi(
          data,
          (res) => {
            toast.success(res.data.result.ResponseMessage);
          },
          (err) => {}
        )
      );
    } catch (error) {}
  }

  // Pending Pagination function
  const handleSearchPending = (e) => {
    // setPage(1)

    setSearchValuePending(e.target.value);
    if (searchValuePending.trim().length >= 2) {
      onChangePagePending(1);
    }
  };
  // PFA Pagination function
  const handleSearchPFA = (e) => {
    // setPage(1)

    setSearchValuePFA(e.target.value);
    if (searchValuePFA.trim().length >= 2) {
      onChangePagePFA(1);
    }
  };

  const handleChangeRowsPerPagePending = (e) => {
    setSearchValuePending("");
    setPagePending(1);
    setPageSizePending(e.target.value);
  };

  const onChangePagePending = (e, p) => {
    // setPage(p);
    setPagePending(e);
  };

  // -----------------------------------------------------------
  const handleChangeRowsPerPagePFA = (e) => {
    setSearchValuePFA("");
    setPagePFA(1);
    setPageSizePFA(e.target.value);
  };

  const onChangePagePFA = (e, p) => {
    // setPage(p);
    setPagePFA(e);
  };

  // -----------------------------------------------------------

  // Approve Pagination Function ----------------------------------------
  const handleSearchApproved = (e) => {
    // setPage(1)

    setSearchValueApproved(e.target.value);
    if (searchValueApproved.trim().length >= 2) {
      onChangePageApproved(1);
    }
  };

  const handleChangeRowsPerPageApproved = (e) => {
    setSearchValueApproved("");
    setPageApproved(1);
    setPageSizeApproved(e.target.value);
  };

  const onChangePageApproved = (e, p) => {
    // setPage(p);
    setPageApproved(e);
  };

  // Payment Pending Pagination Function ----------------------------------------
  const handleSearchPaymentPending = (e) => {
    // setPage(1)

    setSearchValuePaymentPending(e.target.value);
    if (searchValuePaymentPending.trim().length >= 2) {
      onChangePagePaymentPending(1);
    }
  };

  const handleChangeRowsPerPagePaymentPending = (e) => {
    setSearchValuePaymentPending("");
    setPagePaymentPending(1);
    setPageSizePaymentPending(e.target.value);
  };

  const onChangePagePaymentPending = (e, p) => {
    // setPage(p);
    setPagePaymentPending(e);
  };
  // Paid Pagination Function

  const handleSearchPaid = (e) => {
    // setPage(1)

    setSearchValuePaid(e.target.value);
    if (searchValuePaid.trim().length >= 2) {
      onChangePagePaid(1);
    }
  };

  const handleChangeRowsPerPagePaid = (e) => {
    setSearchValuePaid("");
    setPagePaid(1);
    setPageSizePaid(e.target.value);
  };

  const onChangePagePaid = (e, p) => {
    // setPage(p);
    setPagePaid(e);
  };

  // Reject Pagination Function

  const handleSearchReject = (e) => {
    // setPage(1)

    setSearchValueReject(e.target.value);
    if (searchValueReject.trim().length >= 2) {
      onChangePageReject(1);
    }
  };

  const handleChangeRowsPerPageReject = (e) => {
    setSearchValueReject("");
    setPageReject(1);
    setPageSizeReject(e.target.value);
  };

  const onChangePageReject = (e, p) => {
    // setPage(p);
    setPageReject(e);
  };
  // UnBills Pagination Functuion

  const handleSearchUnBills = (e) => {
    // setPage(1)

    setSearchValueUnBills(e.target.value);
    if (searchValueUnBills.trim().length >= 2) {
      onChangePageUnBills(1);
    }
  };

  const handleChangeRowsPerPageUnBills = (e) => {
    setSearchValueUnBills("");
    setPageUnBills(1);
    setPageSizeUnBills(e.target.value);
  };

  const onChangePageUnBills = (e, p) => {
    // setPage(p);
    setPageUnBills(e);
  };

  const formatAuditDate = (dateString) => {
    const date = new Date(dateString);

    // Custom options for formatting the date
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");

    // Options for formatting the time
    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const formattedTime = date.toLocaleTimeString(undefined, timeOptions);

    return `${formattedDate} ${formattedTime}`;
  };

  // Handle tab changes with a switch statement
  const handleTab = (eventKey) => {
    switch (eventKey) {
      case "New":
        setDefaultTabKey("New");
        setOpenTab(2);
        setStatus(2);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        setSearchValueApproved("");
        setSearchValuePaid("");
        setSearchValuePaymentPending("");
        setSearchValuePFA("");
        //  setSearchValuePending("")
        setSearchValueReject("");
        setSearchValueUnBills("");
        setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      case "Pending for Approval":
        setDefaultTabKey("Pending for Approval");
        setOpenTab(9);
        setStatus(9);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        setSearchValueApproved("");
        setSearchValuePaid("");
        setSearchValuePaymentPending("");
        //  setSearchValuePending("")
        setSearchValueReject("");
        setSearchValueUnBills("");
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      case "Approved":
        setDefaultTabKey("Approved");
        setOpenTab(1);
        setStatus(1);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        //  setSearchValueApproved("")
        setSearchValuePaid("");
        setSearchValuePFA("");
        setSearchValuePaymentPending("");
        setSearchValuePending("");
        setSearchValueReject("");
        setSearchValueUnBills("");
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      case "Payment Pending":
        setDefaultTabKey("Payment Pending");
        setOpenTab(3);
        setStatus(3);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        setSearchValueApproved("");
        setSearchValuePaid("");
        setSearchValuePFA("");
        //  setSearchValuePaymentPending("")
        setSearchValuePending("");
        setSearchValueReject("");
        setSearchValueUnBills("");
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      case "Paid":
        setDefaultTabKey("Paid");
        setOpenTab(4);
        setStatus(4);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        setSearchValueApproved("");
        //  setSearchValuePaid("")
        setSearchValuePFA("");
        setSearchValuePaymentPending("");
        setSearchValuePending("");
        setSearchValueReject("");
        setSearchValueUnBills("");
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      case "Rejected":
        setDefaultTabKey("Rejected");
        setOpenTab(5);
        setStatus(5);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        setSearchValueApproved("");
        setSearchValuePaid("");
        setSearchValuePFA("");
        setSearchValuePaymentPending("");
        setSearchValuePending("");
        // setSearchValueReject("")
        setSearchValueUnBills("");
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      case "Unidentified Invoices":
        setDefaultTabKey("Unidentified Invoices");
        setOpenTab(6);
        setStatus(6);
        setFromDate(dayjs(new Date()));
        setToDate(dayjs(new Date()));
        setSearchValueApproved("");
        setSearchValuePaid("");
        setSearchValuePFA("");
        setSearchValuePaymentPending("");
        setSearchValuePending("");
        setSearchValueReject("");
        // setSearchValueUnBills("")
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
      default:
                setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
        break;
    }
  };
  
  const propertiesMenu = findSubMenuByName(permissions, 'Invoice');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Invoice List') : null;

  useEffect(() => {
    if(!listPropertyMenu){
      redirectToDash(navigate,toast)
    }
  
}, [])
  return (
    <>
      <ToastContainer />
      <div className="row">
        <div className="col-xxl-12">
          <div className="card">
            <Tab.Container activeKey={defaultTabKey}>
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="heading me-2">Invoice List</h4>
                <nav>
                  <Nav as="div" className="order nav nav-tabs" role="tablist">
                    {listPropertySubMenus.map((subMenu) => (
                      <Nav.Link
                        key={subMenu.MenuItemName}
                        as="button"
                        eventKey={subMenu.MenuItemName}
                        onClick={() => handleTab(subMenu.MenuItemName)} // Replace handleTab with your logic
                      >
                        {subMenu.MenuItemName}
                      </Nav.Link>
                    ))}
                  </Nav>
                </nav>
              </div>
              <div className="card-body pt-2">
                <Tab.Content>
                  <Tab.Pane eventKey="New">
                    <PendingInvoiceTable
                      tab={defaultTabKey}
                      handleActionPending={handleInvoiceAcceptReject}
                      column={columns}
                      rowsArr={pendingArr}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPagePending
                      }
                      setPageSizePending={setPageSizePending}
                      showLoading={isApiLaoding}
                      searchValuePagination={searchValuePending}
                      pageSizePagination={pageSizePending}
                      handleSearchPagination={handleSearchPending}
                      totalCountPagination={totalPagePending}
                      handleOnChangePagination={onChangePagePending}
                      totalCount={totalPagePendingCount}
                      handleActionMultipleApprove={
                        handleActionMultipleSubmitForApprove
                      }
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                    />
                    {/* <OrderHistory dataArr={pendingArr}  invoiceAction={handleInvoiceAcceptReject}/> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Pending for Approval">
                    <PendingForApprovalInvoiceTable
                      tab={defaultTabKey}
                      handleActionPending={handleInvoiceAcceptReject}
                      column={PFAColumns}
                      rowsArr={pfaArr}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPagePFA
                      }
                      setPageSizePending={setPageSizePFA}
                      showLoading={isApiLaoding}
                      searchValuePagination={searchValuePFA}
                      pageSizePagination={pageSizePFA}
                      handleSearchPagination={handleSearchPFA}
                      totalCountPagination={totalPagePFA}
                      handleOnChangePagination={onChangePagePFA}
                      totalCount={totalPagePFACount}
                      handleActionMultipleApprove={handleActionMultipleApprove}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                      PFAShowAll={PFAShowAll}
                      handlePFACheckboxChange={handlePFACheckboxChange}
                    />
                    {/* <OrderHistory dataArr={pendingArr}  invoiceAction={handleInvoiceAcceptReject}/> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Approved">
                    <ApproveInvoiceTable
                      tab={defaultTabKey}
                      handleActionPending={handleInvoiceAcceptReject}
                      showLoading={isApiLaoding}
                      column={approvedColumns}
                      rowsArr={approvedArr}
                      handleMISFileDownload={handleMISFileDownload}
                      handleDownloadFile={handleFileDownload}
                      handlePaymentFileDownload={handlePaymentFileDownload}
                      handlePaymentAdviceFileDownload={handlePaymentAdviceFileDownload}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPageApproved
                      }
                      setPageSizeApproved={setPageSizeApproved}
                      searchValuePagination={searchValueApproved}
                      pageSizePagination={pageSizeApproved}
                      handleSearchPagination={handleSearchApproved}
                      totalCountPagination={totalPageApproved}
                      handleOnChangePagination={onChangePageApproved}
                      totalCount={totalApprovedCount}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                    />
                    {/* <AllOrder dataArr={approvedArr} /> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Payment Pending">
                    <PendingPaymentInvoiceTable
                      tab={defaultTabKey}
                      handleActionPending={handleInvoiceAcceptReject}
                      column={pendingPaymentsColumn}
                      rowsArr={pendingPaymentArr}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPagePaymentPending
                      }
                      setPageSizePaymentPending={setPageSizePaymentPending}
                      handleDownloadFile={handleFileDownload}
                      showLoading={isApiLaoding}
                      searchValuePagination={searchValuePaymentPending}
                      pageSizePagination={pageSizePaymentPending}
                      handleSearchPagination={handleSearchPaymentPending}
                      totalCountPagination={totalPagePaymentPending}
                      handleOnChangePagination={onChangePagePaymentPending}
                      totalCount={totalpendingPaymentCount}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                      handleMISFileDownload={handleMISFileDownload}
                      handlePaymentFileDownload={handlePaymentFileDownload}
                    />
                    {/* <OrderHistory dataArr={pendingArr}  invoiceAction={handleInvoiceAcceptReject}/> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Paid">
                    <PaidInvoiceTable
                      handleActionPending={handleInvoiceAcceptReject}
                      column={paidColumn}
                      rowsArr={paymentPaidArr}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPagePaid
                      }
                      setPageSizePaid={setPageSizePaid}
                      showLoading={isApiLaoding}
                      searchValuePagination={searchValuePaid}
                      pageSizePagination={pageSizePaid}
                      handleSearchPagination={handleSearchPaid}
                      totalCountPagination={totalPagePaid}
                      handleOnChangePagination={onChangePagePaid}
                      totalCount={totalPaidCount}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                    />
                    {/* <OrderHistory dataArr={pendingArr}  invoiceAction={handleInvoiceAcceptReject}/> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Rejected">
                    <RejectedInvoiceTable
                      handleActionPending={handleInvoiceAcceptReject}
                      column={rejectionColumns}
                      rowsArr={rejectedArr}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPageReject
                      }
                      setPageSizeReject={setPageSizeReject}
                      showLoading={isApiLaoding}
                      searchValuePagination={searchValueReject}
                      pageSizePagination={pageSizeReject}
                      handleSearchPagination={handleSearchReject}
                      totalCountPagination={totalPageReject}
                      handleOnChangePagination={onChangePageReject}
                      totalCount={totalRejectedCount}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                    />
                    {/* <OrderHistory dataArr={pendingArr}  invoiceAction={handleInvoiceAcceptReject}/> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Unidentified Invoices">
                    <UnIdentifiedBillsTable
                      handleActionPending={handleInvoiceAcceptReject}
                      column={unBillColumns}
                      rowsArr={unBillsArr}
                      handleChangeRowsPerPagePagination={
                        handleChangeRowsPerPageUnBills
                      }
                      setPageSizeUnBills={setPageSizeUnBills}
                      showLoading={isApiLaoding}
                      searchValuePagination={searchValueUnBills}
                      pageSizePagination={pageSizeUnBills}
                      handleSearchPagination={handleSearchUnBills}
                      totalCountPagination={totalPageUnBills}
                      handleOnChangePagination={onChangePageUnBills}
                      totalCount={totalUnBillsCount}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      onLoadData={onLoadData}
                      setFilterType={setFilterType}
                    />
                    {/* <OrderHistory dataArr={pendingArr}  invoiceAction={handleInvoiceAcceptReject}/> */}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        </div>
      </div>

      <Modal className="fade" show={permissionModal} centered>
        <Modal.Header>
          <Modal.Title>
            {" "}
            {modaleType === 0 ? "Please provide reason :-" : "Alert"}
          </Modal.Title>
          <Button
            onClick={() => setPermissionModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
            {modaleType === 0 ? (
              <>
                <div className="ps-1 align-self-center">
                  <div className="custom-control custom-checkbox d-flex flex-column ">
                    <label
                      className="custom-control-label"
                      style={{ margin: "0px", color: "black" }}
                    >
                      Reason
                    </label>
                    <textarea
                      className="form-control"
                      style={{ minHeight: "112px" }}
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    ></textarea>
                    &nbsp; &nbsp;
                  </div>
                </div>
              </>
            ) : (
              "Are you sure you want to approve this invoice?"
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setPermissionModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={modaleType == 0 ? handleCancelCalled : handleApproveCalled}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={approveInvoiceModal} centered>
        <Modal.Header>
          <Modal.Title> Approve Invoice</Modal.Title>
          <Button
            onClick={() => setApproveInvoiceModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
            Are you sure you want to approve these invoices ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setApproveInvoiceModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleMultipleApproveCalled();
            }}
            disabled={isApiLaoding}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="fade" show={submitForApproveInvoiceModal} centered>
        <Modal.Header>
          <Modal.Title> Submit For Approval</Modal.Title>
          <Button
            onClick={() => setSubmitForApproveInvoiceModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
            Are you sure you want to submit these invoices for approval?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setSubmitForApproveInvoiceModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleMultipleSubmitForApproveCalled();
            }}
            disabled={isApiLaoding}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Invoice History Table  */}
      <Modal
        size="lg"
        className="fade bd-example-modal-lg"
        show={auditDisplay}
        centered
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            Invoice History
          </Modal.Title>
          <Button
            onClick={() => setAuditDisplay(false)}
            variant="xl"
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Action Performed</TableCell>
                  <TableCell>Performed By</TableCell>
                  <TableCell>Timestamp</TableCell>
                  {filterType!=="Telephone" &&(
                    <TableCell>Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {actionPerformArray.map((item, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell>{item?.ActionPerformed}</TableCell>
                      <TableCell>{item?.ActionPerformedBy}</TableCell>
                      <TableCell>{formatAuditDate(item?.CreatedOn)}</TableCell>
                      <TableCell>
                        {item?.ActionPerformed === "Invoice Updated" &&
                          item?.UpdatedValues !== null && (
                            <IconButton
                              onClick={() => toggleRowExpansion(index)}
                            >
                              {expandedRowIndex === index ? (
                                <KeyboardArrowUp />
                              ) : (
                                <KeyboardArrowDown />
                              )}
                            </IconButton>
                          )}
                      </TableCell>
                    </TableRow>
                    {expandedRowIndex === index && (
                      <TableRow>
                        <TableCell colSpan={4}>
                          <Collapse
                            in={expandedRowIndex === index}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Key</TableCell>
                                  <TableCell>New Value</TableCell>
                                  <TableCell>Old Value</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {parseStringToObjects(item?.UpdatedValues).map(
                                  (valueItem, valueIndex) => (
                                    <TableRow key={valueIndex}>
                                      <TableCell>{valueItem?.Key}</TableCell>
                                      <TableCell>
                                        {valueItem?.NewValue}
                                      </TableCell>
                                      <TableCell>
                                        {valueItem?.OldValue}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {otpModalStatus && (
        <OtpModal
          otpModal={otpModalStatus}
          otp={otpValue}
          handleOtpChange={handleApproveInvoiceOtp}
          handleModalClose={() => {
            setOtpValue("");
            setOtpModalStatus(false);
          }}
          handleProceed={handleMultipleApproveCalled}
          resendOtp={handleResendOtp}
        />
      )}
    </>
  );
};
export default InvoiceList;
